import cx from 'classnames';

import { getDomainsPaths } from '@/utils';
import HeadSeo from '@/components/_App/HeadSeo';
import { ADDITIONAL_ROUTES } from '@/data/pages/routes';

import ReviewsSection from '@/components/ReviewsSection';
import Loader from '@/components/Loader';
import useCatalogScript from '@/hooks/useCatalogScript';
import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';
import Link from 'next/link';

export default function CatalogPage() {
  const router = useRouter();
  const [isIframeLoaded] = useCatalogScript();
  const [isVinSearchDone, setVinSearchDone] = useState(false);

  const vinNumber = router.query.vin;

  useEffect(() => {
    if (vinNumber && isIframeLoaded) {
      const attemptSearchVin = () => {
        try {
          const element = document
            // @ts-ignore
            ?.querySelector(
              '[aria-label="Find the model by VIN or FRAME number"]',
            );

          if (element) {
            // @ts-ignore
            element.value = vinNumber;
            // @ts-ignore
            element?.dispatchEvent(
              new Event('input', {
                // @ts-ignore
                view: globalThis,
                bubbles: true,
                cancelable: true,
              }),
            );

            // @ts-ignore
            document.querySelectorAll('.v-input__append-inner i')[1].click();

            setVinSearchDone(true);
          }
        } catch (e) {
          console.error(e);
        }
      };

      if (!isVinSearchDone) {
        const interval = setInterval(attemptSearchVin, 300);
        return () => clearInterval(interval);
      }
    }
  }, [isIframeLoaded, vinNumber, isVinSearchDone]);

  return (
    <>
      <HeadSeo
        title={ADDITIONAL_ROUTES.catalog.title}
        description={ADDITIONAL_ROUTES.catalog.description}
      />

      <div className="flex bg-white pt-8 px-5">
        <div
          className="p-4 mb-4 text-sm rounded-lg bg-sky-100 text-black"
          role="alert"
        >
          <span className="font-medium">SEARCH NOTE:</span> Enter your
          car&apos;s VIN/Chassis number to the search box below. It&apos;s the
          most accurate and easiest way to search for car parts. How to find a
          VIN number?
          <Link href="/faq#faq-11" className="ml-2 font-bold text-base">
            Click here to find out
          </Link>
          .
        </div>
      </div>
      <div id="widget_oem_catalog"></div>
      {!isIframeLoaded && (
        <div
          className={cx('bg-white', isIframeLoaded && 'items-center flex')}
          style={{ minHeight: '1000px' }}
        >
          <div className="relative flex flex-col items-center justify-center top-[60px]">
            <Loader />
            <div className="mt-10">Loading..</div>
          </div>
        </div>
      )}
      <ReviewsSection />
    </>
  );
}

export async function getStaticPaths() {
  return {
    paths: await getDomainsPaths(),
    fallback: 'blocking',
  };
}

export async function getStaticProps() {
  return {
    revalidate: 3600 * 24 * 30, // set revalidate interval of 30 days
    props: {},
  };
}
